module.exports = __webpack_public_path__ + "img/our2.38d0622e.png";